module.exports = __webpack_public_path__ + "img/Photo_4___Construction_2009_20_212_Canal_Construction_PC_West_St_in_background.2dad5aa4.jpg";